<app-topbar>
</app-topbar>

<app-header></app-header>

<section style="padding: 0 0;" id="home-carosal">

    <div class="home-slider swiper-container" data-aos="fade-up" data-aos-delay="100">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/1.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/2.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/3.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/4.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/1.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/2.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/3.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/4.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/1.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/2.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/3.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/4.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/1.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/2.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/3.png');">
                    </div>
                </div>
            </div>
            <div class="swiper-slide">
                <div class="testimonial-item">
                    <div class="m-auto home-carosal-banner" style="background-image: url('../../assets/img/background/4.png');">
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>
<app-news-feeds></app-news-feeds>
<!-- <app-stocks-banner></app-stocks-banner> -->
<br>
<main id="main">

    <!-- ======= Featured Services Section ======= -->
<!--    <section id="featured-services" class="featured-services">-->
<!--        <div class="container" data-aos="fade-up">-->

<!--            <div class="text-center my-2 section-title">-->
<!--                <h3 data-aos="fade-up" data-aos-delay="100">Become a Pro Trader with-->
<!--                    <span> HAWK </span>-->
<!--                </h3>-->
<!--                <br>-->

<!--                <h6 class=" m-auto">-->
<!--                    Trade as a pro with HAWK. We will awake the Super Trader within you with proper guidance, education, Live market updates, financial news, and streaming services.-->
<!--                </h6>-->

<!--            </div>-->

<!--            <div class="row">-->

<!--                <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">-->
<!--                    <div class="icon-box" data-aos="fade-up" data-aos-delay="100">-->
<!--                        <div class="icon"><i class="bx bx-bulb"></i></div>-->
<!--                        <h4 class="title"> Learn </h4>-->
<!--                        <p class="description">We employ best people and invest in advanced and cutting-edge technologies to ensure that our students learn effectively and acquire the fundamental and technical skills for consistency in theirtrading.</p>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">-->
<!--                    <div class="icon-box" data-aos="fade-up" data-aos-delay="200">-->
<!--                        <div class="icon"><i class="bx bx-transfer"></i></div>-->
<!--                        <h4 class="title"> Trade </h4>-->
<!--                        <p class="description">HAWK group of professional trainers focus on trader skill development and understanding, by using advanced proprietary technologies to boost trader’s ability to recall market patterns and to develop trading strategies that cater-->
<!--                            for a person’s unique personality and temperament.</p>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">-->
<!--                    <div class="icon-box" data-aos="fade-up" data-aos-delay="300">-->
<!--                        <div class="icon"><i class="bx bx-dollar"></i></div>-->
<!--                        <h4 class="title"> Profit </h4>-->
<!--                        <p class="description">Our daily briefings are designed with most accurate financial data and analysis so you can Learn what’s happening in the world of investing in just 5 minutes. We select investing insights from the world’s top investing experts.</p>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </section>-->
    <!-- End Featured Services Section -->

  <!-- ======= subscription Services Section ======= -->
  <section id="subscription-services" class="featured-services">
    <div class="container" data-aos="fade-up">

      <div class="text-center my-2 section-title">
        <h3 data-aos="fade-up" data-aos-delay="100">Become a Pro Trader with
          <span> HAWK </span>
        </h3>
        <br>

        <h6 class=" m-auto">
          Trade as a pro with HAWK. We will awake the Super Trader within you with proper guidance, education, Live market updates, financial news, and streaming services.
          Create free <a [href]="creatAccountUrl">account</a>.
        </h6>

      </div>
      <div class="row">

        <div class="col-md-6 col-lg-4 d-flex featured-services mb-5 mb-lg-0">
          <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="title"> Silver </h4>
              <h2 class="title" style="font-size: 30px">$1000</h2>
            </div>
            <div class="btn d-flex justify-content-center align-items-center">
              <button (click)="goToSubscription()">Subscribe</button>
            </div>
            <p class="description">Daily signals across diverse markets, basic tools, and email support. Ideal for beginners starting their trading journey affordably.</p>
            <menu class="description text-left p-2 icofont-ul">
              <li>No ads</li>
              <li>Custom timeframes</li>
              <li>Custom Range Bars</li>
              <li>Volume profile</li>
              <li>Multiple watchlists</li>
              <li>Bar Replay</li>
              <li>Indicators on indicators</li>
              <li><span class="icofont-check"></span> List Item 1</li>
              <li><span class="icofont-close"></span> <span>List Item 2</span></li>
            </menu>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
          <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="title"> Gold </h4>
              <h2 class="title" style="font-size: 30px">$2500</h2>
            </div>
            <div class="btn d-flex justify-content-center align-items-center">
              <button (click)="goToSubscription()">Subscribe</button>
            </div>
            <p class="description">Daily signals across diverse markets, basic tools, and email support. Ideal for beginners starting their trading journey affordably.</p>
            <menu class="description text-left p-2 ">
              <li>No ads</li>
              <li>Custom timeframes</li>
              <li>Custom Range Bars</li>
              <li>Volume profile</li>
              <li>Multiple watchlists</li>
              <li>Bar Replay</li>
              <li>Indicators on indicators</li>
              <li>Intraday Renko, Kagi, Line Break, Point & Figure charts</li>
              <li>Charts based on custom formulas</li>
              <li>Chart data export</li>
            </menu>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
          <div class="icon-box" data-aos="fade-up" data-aos-delay="300">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="title"> Platinum </h4>
              <h2 class="title" style="font-size: 30px">$5000</h2>
            </div>
            <div class="btn d-flex justify-content-center align-items-center">
              <button (click)="goToSubscription()">Subscribe</button>
            </div>
            <p class="description">Our daily briefings are designed with most accurate financial data and analysis so you can Learn what’s happening in the world of investing in just 5 minutes. We select investing insights from the world’s top investing experts.</p>
            <menu class="description text-left p-2 ">
              <li>No ads</li>
              <li>Custom timeframes</li>
              <li>Custom Range Bars</li>
              <li>Volume profile</li>
              <li>Multiple watchlists</li>
              <li>Bar Replay</li>
              <li>Indicators on indicators</li>
              <li>Intraday Renko, Kagi, Line Break, Point & Figure charts</li>
              <li>Charts based on custom formulas</li>
              <li>Chart data export</li>
              <li>Auto Chart Patterns</li>
              <li>Second-based alerts</li>
              <li>Alerts that don't expire</li>
            </menu>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End subscription Services Section -->


    <!-- ======= About Section ======= -->
    <section id="about" class="about section-bg">
        <div class="container" data-aos="fade-up">

            <div class="section-title">
                <h2>- About -</h2>
                <h3> About <span>HAWK</span></h3>
            </div>

            <div class="row">
                <div class="col-lg-6" data-aos="zoom-out" data-aos-delay="100">
                    <img src="../../assets/img/about/ab.jpg" class="img-fluid" alt="">
                </div>
                <div class="col-lg-6 pt-4 pt-lg-0 content d-flex flex-column
          justify-content-start" data-aos="fade-up" data-aos-delay="100">

                    <p class="text-justify">
                        HAWK International started with a group of ambitious individuals who appreciate independent thinking and most importantly the value of integrity, honesty and friendship. We are a community of professional investors and traders that share the same ideology
                        on how to invest and be profitable in highly competitive local and global markets and develop trading talent. HAWK International helps the investor achieve the realistic returns, identify potential areas, and guide you to be a
                        successful investor and a trader. Our business success relies on engaging a highly diverse team of people across the globe who are client-focused, think differently and draw on a range of backgrounds and experiences to contribute
                        their unique perspective. Together we are relentlessly committed to making a difference and enriching lives!
                    </p>
                </div>
            </div>
<!--            <br>-->
<!--            <br>-->
<!--            <div class="section-title">-->
<!--                <h3> Our <span>Mission</span></h3>-->
<!--            </div>-->

<!--            <div class="row">-->

<!--                <div class="col-lg-6 pt-4 pt-lg-0 content d-flex flex-column-->
<!--          justify-content-start" data-aos="fade-up" data-aos-delay="100">-->

<!--                    <p class="text-justify">-->
<!--                        Our focus and ambition are to develop World Class Traders and Investors. We employ best people and invest in advanced and cutting-edge technologies to ensure that our students learn effectively and acquire the fundamental and technical skills for consistency-->
<!--                        in their trading. HAWK group of professional trainers focus on trader skill development and understanding, by using advanced proprietary technologies to boost trader’s ability to recall market patterns and to develop trading strategies-->
<!--                        that cater for a person’s unique personality and temperament. This unique approach ensures our students are fully immersed into the most cutting edge and relevant training regarding strategies, approach and development techniques-->
<!--                        that keep our traders at the peak of their performance. With your dedication, we will make you a world class trader and an investor!-->
<!--                    </p>-->
<!--                </div>-->
<!--                <div class="col-lg-6" data-aos="zoom-out" data-aos-delay="100">-->
<!--                    <img src="../../assets/img/about/compass.jpg" class="img-fluid" alt="">-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </section>
    <!-- End About Section -->
    <hr style="background-color: rgba(255, 255, 255, 0.137); width: 60%;">

    <!-- ======= Services Section ======= -->
    <section id="Specialized" class="services">
        <div class="container" data-aos="fade-up">

            <div class="section-title">
                <h2>Specialized</h2>
                <h3>What makes <span>HAWK</span> International Unique?</h3>
                <p>Most of the times you will see investing products and training focus on either fundamental or technical analysis. Our research shows the way to succeed in the market you need both to get the complete picture. We accomplish our mission
                    by delivering actionable investing content, comprehensive tools, and educational resources to help you make smarter trading decisions.</p>
            </div>

            <div class="row">

                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
                    <div class="icon-box">
                        <div class="icon"><i class="bx bx-briefcase"></i></div>

                        <h4><a href="">Proficiency</a></h4>
                        <p class="text-dark">
                            Our US and Global market research & analysis are done by professional traders and researchers.
                        </p>
                    </div>
                </div>


                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="150">
                    <div class="icon-box">
                        <div class="icon"><i class="bx bx-donate-heart"></i></div>
                        <h4><a href="">Trust</a></h4>
                        <p class="text-dark">
                            HAWK International is a company which holds the trust of clients over a decade in USA and now expanding its wings to Sri Lanka.
                        </p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="200">
                    <div class="icon-box">
                        <div class="icon"><i class="bx bx-support"></i></div>
                        <h4><a href="">Support</a></h4>
                        <p class="text-dark">
                            Weekly Trainings, Q & A sessions, live stream sessions, tips, and a customer care crew who’s passionate in assisting you!
                        </p>
                    </div>
                </div>


                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="250">
                    <div class="icon-box">
                        <div class="icon"><i class="bx bx-file-find"></i></div>
                        <h4><a href="">Research</a></h4>
                        <p class="text-dark">
                            We offer timely, integrated analysis of companies, sectors, markets and economies, helping clients with their most critical decisions.
                        </p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="300">
                    <div class="icon-box">
                        <div class="icon"><i class="bx bx-health"></i></div>
                        <h4><a href="">Mentorship</a></h4>
                        <p class="text-dark">
                            Enhance your learning with mentorship & guidance designed around your schedule by our experienced Traders
                        </p>
                    </div>
                </div>


                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="350">
                    <div class="icon-box">
                        <div class="icon"><i class="bx bx-group"></i></div>
                        <h4><a href="">Psychology</a></h4>
                        <p class="text-dark">
                            Develop your mindset for sophisticatedresults with a newapproach to trade like a pro.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <hr style="background-color: rgba(255, 255, 255, 0.137); width: 60%;">

    <section class="section-bg">
        <div class="container " data-aos="zoom-in">

            <div class="section-title  ">

                <h3><span>HAWK</span> Daily Briefings – World of investing in just 5 minutes</h3>
                <p>
                    Our daily briefings are designed with most accurate financial data and analysis so you can Learn what’s happening in the world of investing in just 5 minutes. We select investing insights from the world’s top investing experts.
                </p>
                <button class="btn-orange mt-5 mb-0" (click)="register()">Register Now</button>

            </div>
        </div>
    </section>
    <!-- End Clients Section -->

    <hr style="background-color: rgba(255, 255, 255, 0.137); width: 60%;">


<!--<section>-->
<!--    <div class="container" data-aos="fade-up">-->
<!--        <div class="form-group pl-lg-5">-->
<!--            <div class="row align-items-center">-->
<!--                &lt;!&ndash; <div class="col-lg-5 col-md-5 col-sm-12  text-center ">-->
<!--                    <img height="400px" class="ceo-dp m-auto" src="../../assets/img/team/t5.jpg">-->
<!--                </div> &ndash;&gt;-->
<!--                <div class="col-lg-12 col-md-12 col-sm-12">-->
<!--                    <div class="text-center my-2">-->
<!--                        <h3 data-aos="fade-up" data-aos-delay="100"><span> CEO </span> Message</h3>-->
<!--                        <div class="d-flex">-->
<!--                            <img height="70" class="align-self-start" src="../../assets/img/quotat.png">-->
<!--                            <p class="py-5 font-light " style="font-size: large;">-->
<!--                                We at HAWK are firm believers that KNOWLEDGE IS THE BEST INVESTMENT and teaching a person a-->
<!--                                 useful skill can be more beneficial in the long run than filling a need for them temporarily.-->
<!--                                  As the old saying goes,  <b style="color:#e6922e;">“Give a man a fish, and you feed him for a day. Teach a man to fish,-->
<!--                                  and you feed him for a lifetime”.</b>-->
<!--                                     </p>-->

<!--                            <img style="transform:rotate(180deg);" class="align-self-end " height="70" src="../../assets/img/quotat.png">-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</section>-->
<!---->
<!--<hr style="background-color: rgba(255, 255, 255, 0.137); width: 60%;">-->


    <!-- ======= webinar Section ======= -->
    <section id="webinar" class="webinar section-bg">
        <div class="container" data-aos="fade-up">

            <div class="section-title">
                <h2>Learn How to Trade</h2>
                <h3>Upcoming Seminars & Webinars</h3>
            </div>

            <div class="row no-gutter">

                <div class="col-lg-6 col-md-6 flip-card" >
                    <div class="flip-card-inner">
                        <div class="box py-5 flip-card-front">
                            <h2>Webinars</h2>
                            <h5>Boost your trading with <br> HAWK's educational material</h5>
                            <a href="javascript: void(0);"class="btn-text ">Get Now</a>

                        </div>
                        <div class="box flip-card-back" *ngIf="announcementObj['webinar']">
                            <h5>{{ "Webinar will be conducted on topic " + announcementObj['webinar']['topic'] + " on "+ announcementObj['webinar']['date'] + " at " + announcementObj['webinar']['time'] +"."}}</h5>
                            <h5><a href="{{announcementObj['webinar']['description']}}">Click here to join with the session</a></h5>
                        </div>
                        <div class="box flip-card-back" *ngIf="!announcementObj['webinar']">
                            <h5>Our new webinar series will be announced soon. Stay tuned for more exciting information.
                                <br><br>
                                We are glad that you are interested in HAWK International. You can register with us for more exciting information on how to Trade Real Stock in the New York Stock Exchange.
                                </h5>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 flip-card  ">
                    <div class="flip-card-inner">
                        <div class="box py-5 flip-card-front">
                            <h2>Seminars </h2>
                        <h5> Get world-class trading knowledge from <br> HAWK’s team of experts</h5>
                            <a href="javascript: void(0);" class="btn-text ">Get Now</a>

                        </div>
                        <div class="box flip-card-back" *ngIf="announcementObj['seminar']">
                            <h5>{{ "Webinar will be conducted on topic " + announcementObj['seminar']['topic'] + " on "+ announcementObj['seminar']['date'] + " at " + announcementObj['seminar']['time'] +"."}}</h5>
                            <h5><a href="{{announcementObj['seminar']['description']}}">Click here to join with the session</a></h5>
                        </div>
                        <div class="box flip-card-back" *ngIf="!announcementObj['seminar']">
                            <h5>Unfortunately, There are no upcoming Seminars taking place at this moment  due to this prevailing situation.
                                <br><br>
                            We are glad that you are interested in HAWK International. You can register with us for more exciting information on how to Trade Real Stock in the New York Stock Exchange.
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Pricing Section -->


    <!-- ======= Pricing Section ======= -->
    <section id="pricing" class="pricing">
        <div class="container" data-aos="fade-up">

            <div class="section-title">
                <h2>Education</h2>
                <h3>HAWK  <span>Education</span></h3>
                <!-- <p style="width: 100%;">We at HAWK are firm believers that<b style="color:#e6922e;"> KNOWLEDGE IS THE BEST INVESTMENT </b>and teaching a
                    person a useful skill can be more beneficial in the long run than filling a need for
                     them temporarily. As the old saying goes,<i> “<b style="color:#e6922e;">Give</b> a man a fish, and you<b style="color:#e6922e;"> feed him for a day.
                      Teach </b>a man to fish, and you <b style="color:#e6922e;">feed him for a lifetime”</b></i>.

                </p> -->
                <p style="width: 90%; font-size: large">
                   <b style="color:#e6922e;"> IT ALL STARTS WITH A FREE INTRODUCTORY CLASS</b>. Enjoy reading our
                    free material and watch the video demos that will completely change your life. Welcome to the world of Stock Trading!

                </p>
                <button class="btn-orange mt-5 mb-0" [routerLink]="['/education']">View HAWK Education</button>

            </div>

            <div class="row">


<!--
                <div class="col-lg-4 col-md-6 p-card" data-aos="fade-up" data-aos-delay="100">
                    <div class="box">
                        <h3>Free##</h3>
                        <h4><sup>$</sup>0<span> / month</span></h4>
                        <ul>
                            <li>Aida d##ere</li>
                            <li>Nec feugiat nisl</li>
                            <li>Nulla at volut##pat dola</li>
                            <li class="na">Pha##retra massa</li>
                            <li class="na">Massa## ultricies mi</li>
                        </ul>
                        <div class="btn-wrap">
                            <a href="#" class="btn-buy btn-transparent">Get Now</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6  p-card" data-aos="fade-up" data-aos-delay="200">
                    <div class="box featured">
                        <h3>Busine##ss</h3>
                        <h4><sup>$</sup>19<span> / month</span></h4>
                        <ul>
                            <li>Aida de##re</li>
                            <li>Nec fe##ugiat nisl</li>
                            <li>Nulla## at volutpat dola</li>
                            <li>Pharet##ra massa</li>
                            <li class="na">Mas##sa ultricies mi</li>
                        </ul>
                        <div class="btn-wrap">
                            <a href="#" class="btn-buy">Get Now</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6  p-card" data-aos="fade-up" data-aos-delay="400">
                    <div class="box">
                        <span class="advanced">Advanced</span>
                        <h3>Ultim##ate</h3>
                        <h4><sup>$</sup>49<span> / month</span></h4>
                        <ul>
                            <li>Aida## dere</li>
                            <li>Nec ##feugiat nisl</li>
                            <li>Null##a at volutpat dola</li>
                            <li>Phar##etra massa</li>
                            <li>Massa ultricies mi</li>
                        </ul>
                        <div class="btn-wrap">
                            <a href="#" class="btn-buy">Get Now</a>
                        </div>
                    </div>
                </div> -->


            </div>
        </div>
    </section>
    <!-- End Pricing Section -->

    <!-- ======= Frequently Asked Questions Section ======= -->
<!--    <section id="faq" class="faq section section-bg">-->
<!--        <div class="container" data-aos="fade-up">-->

<!--            <div class="section-title">-->
<!--                <h2>F.A.Q</h2>-->
<!--                <h3>Some important <span>F.A.Q</span></h3>-->
<!--            </div>-->

<!--            <ul class="faq-list " data-aos="fade-up" data-aos-delay="100">-->
<!--                <li>-->
<!--                    <a data-toggle="collapse" class="collapsed" href="#faq1">-->
<!--                  What Are The Qualifications And Requirements I Should Have For This Training?-->
<!--                  <i class="icofont-simple-up"></i></a>-->
<!--                    <div id="faq1" class="collapse " data-parent=".faq-list">-->
<!--                        <p>-->
<!--                            Basically the requirement for this is your commitment and interest towards learning about the stock market. Apart from that you need to have Basic English knowledge and Basic computer knowledge. Our team has developed this content in a way that anybody-->
<!--                            can understand and we will be guiding you throughout the journey. Also you will be needing a laptop/Desktop or a mobile phone as this is a web based training.-->
<!--                        </p>-->
<!--                    </div>-->
<!--                </li>-->

<!--                <li>-->
<!--                    <a data-toggle="collapse" class="collapsed" href="#faq2">-->
<!--                      What Is The Duration Of This Training? What Do We Have To Learn About During This Training?-->
<!--                      <i class="icofont-simple-up"></i></a>-->
<!--                    <div id="faq2" class="collapse " data-parent=".faq-list">-->
<!--                        <p>-->
<!--                            Duration of training would be 3 months. We will be having 20 hours of theory sessions followed up by 10 hours of practical sessions. During theoretical sessions, we will be teaching about end to end understanding about the stock market. During the practical-->
<!--                            session, we will be guided to trade with paper money until you become fit to trade with real money. And most importantly we will be teaching you how to manage your money while you are trading and to develop trader’s mindset.-->
<!--                        </p>-->
<!--                    </div>-->
<!--                </li>-->

<!--                <li>-->
<!--                    <a data-toggle="collapse" class="collapsed" href="#faq3">-->
<!--                      How Much Can I Earn After Following This Training?-->
<!--                      <i class="icofont-simple-up"></i></a>-->
<!--                    <div id="faq3" class="collapse " data-parent=".faq-list">-->
<!--                        <p>-->
<!--                            First of all Stock trading is not a way of making quick money. It’s all depending on the effort that you are putting to understand. Stock trading is not-->
<!--                            a one time trade, but it’s a journey that you need to practice and learn. Once you understand the procedures, the profit margin can be improved.-->
<!--                        </p>-->
<!--                    </div>-->
<!--                </li>-->

<!--                <li>-->
<!--                    <a data-toggle="collapse" class="collapsed" href="#faq4">-->
<!--                      Don’t You Face Losses While Trading?-->
<!--                      <i class="icofont-simple-up"></i></a>-->
<!--                    <div id="faq4" class="collapse " data-parent=".faq-list">-->
<!--                        <p>-->
<!--                            Stock Trading is based on profits and losses. Every trader in this world faces losses. But we teach you how to minimize the losses and to understand a loss before it gets worse. Also once you take our training, you’ll be getting a free subscription for-->
<!--                            three months of our market analyzing service. We will be providing you market analysis done by HAWK USA. Using this information you can minimize the losses while you are trading.-->
<!--                        </p>-->
<!--                    </div>-->
<!--                </li>-->
<!--                <li>-->
<!--                    <a data-toggle="collapse" class="collapsed" href="#faq5">-->
<!--                      How Do I Join The Training?<i class="icofont-simple-up"></i></a>-->
<!--                    <div id="faq5" class="collapse " data-parent=".faq-list">-->
<!--                        <p>-->
<!--                            We will be enrolling students in 2 batches for a single month. Each batch would be consist of Maximum 50 students. First you will have to register on our website. Once you get registered, you will be having free content where you can learn more about-->
<!--                            the New York Stock Exchange as well as the training. While you are referring to the content one of our agents will contact you and guide you with the enrollment.</p>-->
<!--                    </div>-->
<!--                </li>-->
<!--            </ul>-->

<!--        </div>-->
<!--    </section>-->
    <!-- End Frequently Asked Questions Section -->


    <!-- ======= Contact Section ======= -->
    <section id="contact" class="contact ">
        <div class="container" data-aos="fade-up">

          <div class="d-flex justify-content-center">
            <p style="width: 90%; font-size: large; text-align: center">
              Need help? Check out our <a routerLink="/faq">faq</a> for quick answers to popular inquiries.
            </p>
          </div>

            <div class="section-title">
                <h2>Contact</h2>
                <h3><span>Contact Us</span></h3>
            </div>

            <div class="row" data-aos="fade-up" data-aos-delay="100">
                <div class="col-lg-6">
                    <div class="info-box mb-4">
                        <i class="bx bx-map"></i>
                        <h3>Our Address</h3>
                        <p>Level 05, East Low Block, World Trade Center, Colombo 01</p>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6">
                    <div class="info-box mb-4">
                        <i class="bx bx-envelope"></i>
                        <h3>Email Us</h3>
                        <p>info@HAWKinterational.com</p>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6">
                    <div class="info-box mb-4">
                        <i class="bx bx-phone-call"></i>
                        <h3>Call Us</h3>
                        <p>+94 11 429 4747</p>
                        <p>+94 11 429 4748</p>
                    </div>
                </div>
            </div>

            <div class="row" data-aos="fade-up" data-aos-delay="100">

                <div class="col-lg-6">
                    <iframe class="mb-4 mb-lg-0" style="border-radius: 2rem;"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.6474756115294!2d79.84156891459286!3d6.932670094991054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae25925ab4dc561%3A0xeb35822a3ace0857!2sWorld%20Trade%20Center!5e0!3m2!1sen!2slk!4v1624901787557!5m2!1sen!2slk"
                        frameborder="0" style="border:0; width: 100%; height: 384px;" allowfullscreen></iframe>
                </div>

                <div class="col-lg-6" style="border-radius: 10px;">
                    <form action="forms/contact.php" method="post" role="form" class="php-email-form">
                        <div class="form-row">
                            <div class="col form-group">
                                <input type="text" name="name" class="form-control" id="name" placeholder="Your Name" data-rule="minlen:4" data-msg="Please
                  enter at least 4 chars" />
                                <div class="validate"></div>
                            </div>
                            <div class="col form-group">
                                <input type="email" class="form-control" name="email" id="email" placeholder="Your Email" data-rule="email" data-msg="Please
                  enter a valid email" />
                                <div class="validate"></div>
                            </div>
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" name="subject" id="subject" placeholder="Subject" data-rule="minlen:4" data-msg="Please enter at least 8 chars of subject" />
                            <div class="validate"></div>
                        </div>
                        <div class="form-group">
                            <textarea class="form-control" name="message" rows="5" data-rule="required" data-msg="Please write something for us" placeholder="Message"></textarea>
                            <div class="validate"></div>
                        </div>
                        <div class="mb-3">
                            <div class="loading">Loading</div>
                            <div class="error-message"></div>
                            <div class="sent-message">Your message has been sent. Thank you!</div>
                        </div>
                        <div class="text-center py-2"><button class="btn-orange" type="submit">Send Message</button></div>
                    </form>
                </div>
            </div>
        </div>
    </section>
    <!-- End Contact Section -->

</main>
<!-- End #main -->
